<template>
  <div class="modal-container" ref="modalContainer">
    <div class="form-content-body">
      <div class="row">
        <div
            class="col-md-12 text-center modal-header px-4 align-items-center"
        >
          <div class="header-container row w-100 py-2">
              <h3 class="col-11 text-left ml-3">Learn more about the data that you are eligible to view</h3>
              <button class="close close-btn text-right col-1" @click="closePopup">
                <img src="../assets/images/icon-close.svg" />
              </button>
          </div>
        </div>
      </div>
        <div class="row no-gutters mt-3 mx-5 pb-2">
          <table class="table-responsive">
            <thead>
            <tr>
              <th>Types of invoices</th>
              <th>Role</th>
              <th>Can view purchase order details?</th>
              <th>Can view invoice status?</th>
              <th>Can copy the webform (non-purchase order, purchase order without invoice)</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th rowspan="7">Purchase order invoices</th>
              <td>Submitter</td>
              <td>Yes</td>
              <td>Yes</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Direct manager of submitter</td>
              <td>No</td>
              <td>No</td>
              <td>No</td>
            </tr>
            <tr>
              <td>Purchase order preparer</td>
              <td>Yes</td>
              <td>Yes</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Purchase order requester</td>
              <td>Yes</td>
              <td>Yes</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Direct manger of purchase order requester</td>
              <td>Yes</td>
              <td>Yes</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Cost center owner</td>
              <td>Yes</td>
              <td>Yes</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Cost center finance business partner</td>
              <td>Yes</td>
              <td>Yes</td>
              <td>Yes</td>
            </tr>
            <tr>
              <th rowspan="3">Non-purchase order invoices</th>
              <td>Submitter</td>
              <td>N/A</td>
              <td>Yes</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Direct manager of submitter</td>
              <td>N/A</td>
              <td>Yes</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Cost center owner</td>
              <td>N/A</td>
              <td>Yes</td>
              <td>Yes</td>
            </tr>
            </tbody>
          </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PoFilterFAQModal",
  methods :{
    closePopup(){
      this.$parent.$emit('onClosed')
    },
  },

}
</script>

<style scoped>

table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  padding: 5px;
  text-align: center;
}
.modal-container {
  background-color: #fff;
  overflow-y: auto !important;
  height: 100%;
  overflow-x: hidden;
}

.modal-container {
  padding-bottom: 20px;
}

@media (max-width: 800px) {
  .modal-container {
    height: 55vh;
  }
}

.form-content-body {
  height: 100%;
}

.modal-header {
  height: 100% !important;
}

</style>